import React, { Component, Fragment } from 'react';
import { Redirect } from "react-router";
import { withTranslation } from "react-i18next";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import Loading from "./Parts/Loading";
import AppContext from "../../contexts/AppContext";

const ContractEmbeddedPdf = (props) => {
    return (
        <embed className="embed-document__item border border-primary" src={props.src} key={props.src}/>
    );
};

class ViewContract extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            show_contract: false,
            step_count: 4,
            current_step: 3,
            redirectToNextStep: false,
            redirect_url: null
        };

        axios.get('/api/process/' + this.props.application_token + '/make_contract')
            .then(
                data => {
                    if (data.data.status === 'success') {
                        gtm.sendEvent('base', {
                            orderID: this.props.suggestion.application.id,
                            event: 'checkoutcontract2',
                            actionField: { step: 8, action: 'viewContract'},
                            products: {
                                price: this.props.suggestion.amount,
                                variant: this.props.suggestion.term,
                                product_code: this.props.suggestion.type,
                            },
                            pageTitle: 'Sign the contract 2/3 document',
                            eventId: 2913
                        });
                        this.setState({ show_contract: true });
                    }
                }
            ).catch((error) => {
                gtm.sendEvent('base', {
                    orderID: this.props.suggestion.application.id,
                    event: 'failure',
                    actionField: {step: 8, action: 'viewContract'},
                    products: {
                        product_code: this.props.suggestion.type,
                        error: error.response.data.error_code
                    },
                    pageTitle: 'Sign the contract 2/3 document',
                    eventId: 2913
                });
        });

        this.goToContractSign = this.goToContractSign.bind(this);
    }

    goToContractSign() {
        this.props.refreshApplData().then(() => {
            this.setState({ redirectToNextStep: true });
        });
    }

    render() {
        const { hasError } = this.context;

        if (this.state.redirectToNextStep) {
            return <Redirect push={true} to={'/' + this.props.application_token + '/process/sign_contract'} />
        }

        if (this.state.redirect_url !== null && this.state.redirect_url !== undefined) {
            return <Redirect push={true} to={this.state.redirect_url} />
        }

        return (
            <Fragment>
                <Header title={this.props.t('step.contract')} />

                <div className="section window-layout">
                    <div className="container frame">
                        <SubHeader
                            title={this.props.t('substep.view_contract')}
                            step_count={this.state.step_count}
                            current_step={this.state.current_step}
                        />

                        {!hasError &&
                            <Fragment>
                                {!this.state.show_contract ?
                                    <Loading/>
                                    :
                                    <div className="container form-layout__2-col">
                                        <div
                                            className="form-group col-12 col-md-6 d-flex flex-column align-items-start mt-5">
                                            <a href={'/api/process/' + this.props.application_token + '/download_contract_pdf'}
                                            className="link link-primary line-animation mt-3">
                                                <i className="icons icon-file-download"></i> {this.props.t('forms.download_contract')}
                                            </a>
                                        </div>

                                        <div className="form-group col-12 col-md-6 d-flex flex-column align-items-end mt-5">
                                            <a href={'/api/process/' + this.props.application_token + '/contract_pdf'}
                                            target="_blank"
                                            className="link link-primary line-animation mt-3">
                                                <i className="icons icon-file-pdf"></i> {this.props.t('forms.open_in_new_tab')}
                                            </a>
                                        </div>

                                        <div className="form-group col-12 d-flex flex-column align-items-center mt-5">
                                            <p>
                                                Paspaudus mygtuką "Pasirašyti sutartį" bus laikoma, kad jūs tinkamai
                                                susipažinote, supratote ir sutinkate su sutarties tekstu. Priešingu atveju
                                                sutartį sudarykite tik tai atlikę
                                            </p>
                                            <button className="btn btn-primary btn-lg" onClick={this.goToContractSign}>
                                                {this.props.t('forms.sign_contract')}
                                            </button>
                                        </div>
                                    </div>
                                }
                            </Fragment>
                        }
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default withTranslation()(ViewContract);
